import { render, staticRenderFns } from "./shipments-table.vue?vue&type=template&id=a9847d10&scoped=true"
import script from "./shipments-table.vue?vue&type=script&lang=js"
export * from "./shipments-table.vue?vue&type=script&lang=js"
import style0 from "./shipments-table.vue?vue&type=style&index=0&id=a9847d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9847d10",
  null
  
)

export default component.exports